import { notify } from '@eleveo/components-react';
import { AxiosInstance } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';

import { ErrorHandlerFunction } from './types';
import { useDataProvider } from '../app/DataProvider';
import { RoleOption } from '../components/forms/roles/types';
import { EndpointsFactory } from '../constants/integrationConstants';

export const ELEVEO_USER_ROLES_ROOT_KEY = 'eleveo-user-roles';

export const handleEleveoUserRolesErrors: ErrorHandlerFunction = (queryKey, t) => {
  const isEleveoUserRolesError = queryKey === ELEVEO_USER_ROLES_ROOT_KEY;

  if (isEleveoUserRolesError) {
    notify.error(t('myConfigurations.roleMapping.response.failedEleveoRoles'));
  }

  return isEleveoUserRolesError;
};

export const fetchEleveoUserRoles = (client: AxiosInstance) => (): Promise<RoleOption[]> =>
  EndpointsFactory.getEleveoUserRoles(client);

export function useEleveoUserRolesQuery(
  options: UseQueryOptions<RoleOption[], Error, RoleOption[], typeof ELEVEO_USER_ROLES_ROOT_KEY> = {}
) {
  const { client } = useDataProvider();

  return useQuery(ELEVEO_USER_ROLES_ROOT_KEY, fetchEleveoUserRoles(client), {
    ...options,
  });
}
